var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaderecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7787 7.33336L7.20273 3.75736L8.1454 2.8147L13.3307 8.00003L8.1454 13.1854L7.20273 12.2427L10.7787 8.6667H2.66406V7.33336H10.7787Z",
    fill: "#03053D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaderecha);
export default __webpack_public_path__ + "static/media/flechaderecha.d2b0ce7beebc29080bb491212a73e1a3.svg";
export { ForwardRef as ReactComponent };